"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require("react-redux");

var _GarageSelector = require("../../components/steps/GarageSelector");

var _GarageSelector2 = _interopRequireDefault(_GarageSelector);

var _form = require("../../actions/form");

var _garage = require("../../actions/garage");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadGarages: function loadGarages() {
      dispatch((0, _garage.loadGarages)());
    },
    submit: function submit(stepId, formData) {
      dispatch((0, _form.submitFormData)(formData));
      dispatch((0, _form.finishStep)(stepId));
      dispatch((0, _form.selectNextStep)());
    }
  };
}

function mapStateToProps(state) {
  var garage = state.garage,
      formData = state.formData;
  var garages = garage.garages;
  var garageId = formData.garageId;
  return {
    garages: garages,
    selectedGarage: garageId
  };
}

var GarageSelectionContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_GarageSelector2.default);
exports.default = GarageSelectionContainer;